import { OnVariablesChanged } from '../DataTableQuery.types';

export function isEmptyQueryOrSort(
  obj: { query?: OnVariablesChanged<any, any>['query']; sort?: OnVariablesChanged<any, any>['sort'] } | undefined | null
) {
  return isEmptyObject(obj?.query) && isEmptyArray(obj?.sort);
}

const isEmptyObject = (obj: any) => {
  if (obj === null || obj === undefined) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

const isEmptyArray = (arr: any) => {
  if (arr === null || arr === undefined) {
    return true;
  }
  return Array.isArray(arr) && arr.length === 0;
};
